import { render, staticRenderFns } from "./Merchant.vue?vue&type=template&id=74b6e631&scoped=true&"
import script from "./Merchant.vue?vue&type=script&lang=js&"
export * from "./Merchant.vue?vue&type=script&lang=js&"
import style0 from "./Merchant.vue?vue&type=style&index=0&id=74b6e631&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b6e631",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/development/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74b6e631')) {
      api.createRecord('74b6e631', component.options)
    } else {
      api.reload('74b6e631', component.options)
    }
    module.hot.accept("./Merchant.vue?vue&type=template&id=74b6e631&scoped=true&", function () {
      api.rerender('74b6e631', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shopApp/routes/shop/merchant/Merchant.vue"
export default component.exports